import { render, staticRenderFns } from "./searchengine.vue?vue&type=template&id=b81c51e4&scoped=true&"
import script from "./searchengine.vue?vue&type=script&lang=js&"
export * from "./searchengine.vue?vue&type=script&lang=js&"
import style0 from "./searchengine.vue?vue&type=style&index=0&id=b81c51e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81c51e4",
  null
  
)

export default component.exports